import { Controller } from "react-hook-form";
import styled from "styled-components";
import { Pmb, P } from "./Typography";
import { forwardRef } from "react";
import { ErrorMessage } from '@hookform/error-message';
import theme from "../common/theme";

const Input = styled.textarea`
    flex: 1;
    outline: none;
    padding: 1rem;
    font-size: 1rem;
    background: ${theme.palette.light};
    border: 1px solid ${theme.palette.light};
    margin-top: 0.5rem;
    font-family: "Roboto Condensed";    

    &::placeholder {
        font-family: "Roboto Condensed";
        color: ${theme.palette.dark};
        font-size: 14px;
    }
`

const Container = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    margin: 1rem 0;
`

export const UncontrolledFormTextAreaInput = forwardRef(({ errors, label, containerStyle, ...rest }, ref) => {
    return (
        <Container style={containerStyle}>
            <Pmb>{label}</Pmb>
            <Input
                ref={ref}
                {...rest}
            />
            {errors && <ErrorMessage
                errors={errors}
                name={rest.name}
                render={({ message }) => <P style={{ color: 'red' }}>{message}</P>}
            />}
        </Container>
    )
})

export default ({ name, control, rules, ...rest }) => {
    return (
        <Controller
            name={name}
            control={control}
            rules={rules}
            render={({ field: { ...fieldProps } }) => (
                <UncontrolledFormTextAreaInput {...fieldProps} {...rest} />
            )}
        />
    );
};
